import { gql } from '@apollo/client'

export default gql`
  query  listWhitelistedIps($project: String!){
    listWhitelistedIps(project: $project){
        ip
    }
  }
`
